/**
 * useJsonFileDrop - a .json file dropped anywhere on the page is read as text.
 *
 * Page-wide, so "drop the character file on the roster" needs no aiming.
 * It only takes drops nobody else claimed: the handouts drawer, the
 * waiting rooms and the weapon rows handle their own and call
 * preventDefault, which this listener (on window, so it runs after them)
 * reads as "taken". Files of any other kind are ignored - but still
 * prevented, since the browser's own answer to a dropped file is to
 * navigate away from the session.
 *
 * @param {(text: string) => void} onText - called once per dropped .json file
 */
import { useEffect } from 'react';

const carriesFiles = (e) => Array.from(e.dataTransfer?.types ?? []).includes('Files');
const isJson = (file) => file.name.toLowerCase().endsWith('.json');

export default function useJsonFileDrop(onText) {
  useEffect(() => {
    const allow = (e) => {
      if (!e.defaultPrevented && carriesFiles(e)) e.preventDefault();
    };
    const take = (e) => {
      if (e.defaultPrevented || !carriesFiles(e)) return;
      e.preventDefault();
      for (const file of Array.from(e.dataTransfer.files).filter(isJson)) {
        file.text().then(onText, (err) => console.error('[import] could not read the dropped file', err));
      }
    };
    window.addEventListener('dragover', allow);
    window.addEventListener('drop', take);
    return () => {
      window.removeEventListener('dragover', allow);
      window.removeEventListener('drop', take);
    };
  }, [onText]);
}
